module.exports = __webpack_public_path__ + "img/your_sextoy.19a2b56c.jpg";